// Chapter markers for the AI 2040 VO narration (public/audio/ai-2040-vo-edited.mp3).
// `start` is the offset in seconds where each chapter begins in the combined
// file. These offsets are derived from the encoded MP3 segment durations and
// mirror public/audio/ai-2040-vo-chapters.json (the source-of-truth data file).
// The player uses them to draw hover markers at each chapter break.
export interface AudioChapter {
  title: string;
  start: number;
}

export const AUDIO_CHAPTERS: AudioChapter[] = [
  { title: 'Introduction', start: 0 },
  { title: '2027: The Writing on the Wall', start: 48.562 },
  { title: '2028: AI on the Ballot', start: 189.649 },
  { title: '2029: Choose a Path', start: 513.202 },
  { title: '2030: Plan A is Established', start: 815.331 },
  { title: '2031: Safety Cases', start: 1327.566 },
  { title: '2032: Controlled Explosive Growth', start: 1757.385 },
  { title: '2033: The Citizen’s Dividend', start: 1994.133 },
  { title: '2034: Mutually Assured Compute Destruction', start: 2234.982 },
  { title: '2035: Pause at Top Expert AI', start: 2369.852 },
  { title: '2036: Life After Work', start: 2649.179 },
  { title: '2037: The Apocalyptic Arrival of Truth on Earth', start: 2937.702 },
  { title: '2038: AI Alignment Is Now a Science', start: 3211.256 },
  { title: '2039: Beginning to Trust AIs', start: 3370.76 },
  { title: '2040: Passing the Torch to AIs', start: 3531.047 },
  { title: 'Postscript', start: 3717.561 },
];
